import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { getTime } from 'date-fns';
import { Subscription } from 'rxjs';

import { CoupleList } from 'src/app/interfaces/account';
import { AccountInfo } from 'src/app/interfaces/account';
import { AccountInfoService } from 'src/app/services/account/account-info.service';
import { DateTimeService } from 'src/app/services/general/date-time.service';
import { LanguageService } from 'src/app/services/general/language.service';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss'],
})
export class AccountInfoComponent implements OnInit, OnDestroy {

  /**
   * Day count down
   */
  days: number;
  /**
   * Hours count down
   */
  hours: number;
  /**
   * Minutes count down
   */
  minutes: number;
  /**
   * Account info
   */
  accountInfo: AccountInfo;

  coupleList: {
    [coupleId: string]: CoupleList
  };

  /**
   * Constructor
   * @param modalController Modal controller
   */
  constructor(
    private modalController: ModalController,
    private dateTimeService: DateTimeService,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  /**
   * Before view will enter
   */
  ionViewWillEnter() {
    this.setupDuration();
    this.setupCoupleList();
  }

  /**
   * Setup count down duration
   */
  setupDuration() {
    if (this.accountInfo?.time?._seconds) {
      const time  = this.accountInfo.time._seconds * 1000;
      let date = (time - getTime(new Date())) / 1000;
      if (date > 0) {
        this.days = Math.floor(date / 86400);
        date -= this.days * 86400;

        this.hours = Math.floor(date / 3600) % 24;
        date -= this.hours * 3600;

        this.minutes = Math.floor(date / 60) % 60;
        date -= this.minutes * 60;
      }
    } else {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
    }
  }

  setupCoupleList() {
    if (!this.coupleList) {
      this.coupleList = {};
    }
    if (this.accountInfo?.coupleList?.length) {
      this.coupleList[1] = this.getCoupleName(1);
      this.coupleList[2] = this.getCoupleName(2);
    }
  }

  getLanguageCode() {
    return this.languageService.getUserLanguage()?.code;
  }

  /**
   * Get couple name
   * @param coupleId couple id
   * @returns couple list
   */
  getCoupleName(coupleId: number): CoupleList {
    if (this.accountInfo?.coupleList?.length) {
      const index = this.accountInfo?.coupleList?.findIndex((coupleName: CoupleList) => coupleName?.accountCouple?.coupleId === coupleId);
      if (index !== -1) {
        return this.accountInfo.coupleList[index];
      }
    }
    return;
  }

  format(timestamp: number, dateTimeFormat: string, timezone?: string) {
    return this.dateTimeService.format(timestamp, dateTimeFormat, '', timezone);
  }

  /**
   * Dismiss modal
   * @param anonymous Anonymous
   */
  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { await modal.dismiss(); }
    }
  }
}
